import {useMutation, useQueryClient} from '@tanstack/react-query';
import {ConversationMessage} from '@/types/conversationMessage';
import contentSubmissionVersionMessagesUpdaters from '@/api/updaters/contentSubmissionVersionMessages';
import {CONTENT_SUBMISSION_VERSION_MESSAGES_QUERY_KEY} from '@/hooks/queries/use-content-submission-version-messages';

type SendVersionMessageParams = {
  versionId: string;
  body: string;
  sentFromBrandId?: string;
};

function useSendVersionMessage() {
  const queryClient = useQueryClient();

  return useMutation<ConversationMessage, Error, SendVersionMessageParams>({
    mutationKey: ['contentSubmissionVersions', 'sendMessage'],
    mutationFn: contentSubmissionVersionMessagesUpdaters.sendMessage,
    onSuccess: (data, variables) => {
      const queryKey = [
        CONTENT_SUBMISSION_VERSION_MESSAGES_QUERY_KEY,
        variables.versionId,
      ];
      // Insert immediately so the Creator-tab empty copy hides before the
      // invalidated refetch completes (cached data stays [] while isFetching).
      queryClient.setQueryData<ConversationMessage[]>(queryKey, (old) => {
        if (!old) {
          return [data];
        }
        if (old.some((message) => message.id === data.id)) {
          return old;
        }
        return [...old, data];
      });
      queryClient.invalidateQueries({queryKey});
    },
  });
}

export default useSendVersionMessage;
